<template>
    <div class="layout-container-box">
      <el-header class="layout-header">
        <Header>
          <template #header-brand>
            <BreadCrumb :breadList="breadList" />
          </template>
        </Header>
      </el-header>
      <div class="main_box">
        <div class="title_box">
            <h1>{{ DetailInfo.base.title }}</h1>
            <h3>报名人数(待审核/审核通过/总数):{{ DetailInfo.base.no_check_num }}/{{ DetailInfo.base.is_check_num }}/{{ DetailInfo.base.register_num }}</h3>
        </div>
        <div class="search_box">
            <div class="search_box_input">
              <ul class="serch_list">
                <!-- <li>
                  <span>姓名</span>
                  <el-input v-model="search" placeholder="请输入姓名" class="search_inp"></el-input>
                </li>
                <li>
                  <span>是否付费</span>
                  <el-select class="mg-r-12" v-model="selectValue" @change="selectChange">
                    <el-option
                      v-for="option in payOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    ></el-option>
                  </el-select>
                </li> -->
                <li>
                  <span>支付状态</span>
                  <el-select class="mg-r-12" clearable v-model="payState" @change="selectChange">
                    <el-option
                      v-for="option in paymentOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    ></el-option>
                  </el-select>
                </li>
                <li v-if="DetailInfo.base.is_check==2">
                  <span>审核状态</span>
                  <el-select class="mg-r-12" clearable v-model="stateValue" @change="selectChange">
                    <el-option
                      v-for="option in stateOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    ></el-option>
                  </el-select>
                </li>
              </ul>

              <el-button type="primary" @click="handleSearch">查询</el-button>
            </div>
            <div class="export">
                <el-button type="primary" @click="handleExport">导出</el-button>
            </div>

            <!-- <SearchFilterBar
            :addShow="false"
            :exportShow="true"
            :statusFlag="false"
            :exportUrl="exportUrl"
          /> -->
        </div>
        <div class="data_box">
            <div class="pd-32" style="background: #fff">
                  <el-table :data="ListData" border>
                    <el-table-column
                      prop="nick_name"
                      width="90"
                      align="center"
                      label="昵称"
                    />
                    <!-- <el-table-column
                      name="title"
                      prop="title"
                      label="昵称"
                      show-overflow-tooltip
                      width="300"
                    /> -->
                    <el-table-column
                      prop="pay_status"
                      width="100"
                      align="center"
                      label="支付状态"
                    >
                    <template #default="scope">
                      {{ scope.row.pay_status==1?'未支付':scope.row.pay_status==2?'支付失败':scope.row.pay_status==3?'支付完成':'免费' }}
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="check_status"
                      width="100"
                      align="center"
                      label="审核状态"
                    >
                    <template #default="scope">
                      <div v-if="DetailInfo.base.is_check==2">
                        {{ scope.row.check_status==1?'未审核':scope.row.check_status==2?'审核通过':'审核失败' }}
                      </div>
                      <div v-else>无需审核</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="reason"
                      width="160"
                      show-overflow-tooltip
                      align="center"
                      label="审核失败原因"
                    />
                    <el-table-column
                      prop="operator_name"
                      width="180"
                      align="center"
                      label="操作人"
                    />
                    <el-table-column
                      prop="check_status"
                      width="100"
                      align="center"
                      label="报名详情"
                    >
                    <template #default="scope">
                      <el-link
                                type="primary"
                                @click="handleDetail(scope.row.content)"
                                >报名详情</el-link
                              >
                    </template>
                    </el-table-column>


                    <el-table-column
                      label="操作"
                      align="center"
                      fixed="right"
                    >
                      <template #default="scope">
                        <div v-if="DetailInfo.base.is_check==2">
                          <div v-if="scope.row.check_status==1" >
                              <el-link
                                type="primary" 
                                @click="handleAudit(scope.row.id,2 )"
                                style="margin-right: 20px;"
                                >审核通过</el-link
                              >
                              <el-link
                                type="primary"
                                @click="handleAudit(scope.row.id,3)"
                                >审核不通过</el-link
                              >
                            </div>
                            <div v-else> 
                                已审核
                              </div>
                        </div>
                        <div v-else>
                          无需审核
                        </div>
                        
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="table-pagination-row mg-t-24">
                    <!-- v-show="paginationData.total > paginationData.size" -->
                    <el-pagination
                     
                      :background="background"
                      v-model:current-page.sync="paginationData.current"
                      v-model:page-size.sync="paginationData.size"
                      :layout="layout"
                      :total="paginationData.total"
                      v-bind="$attrs"
                      @current-change="handleCurrentChange"
                      @pagination="getInfo"
                    />
                  </div>
                </div>
        </div>
      </div>
      <el-dialog
        v-model="dialogVisible"
        title="填写不通过原因"
        width="30%"
      >
      <el-input
        v-model="reason"
        :rows="2"
        type="textarea"
        placeholder="请填写审核不通过原因"
        :before-close="closeDialog"
      />
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmReason">
              审核不通过
            </el-button>
          </span>
        </template>
      </el-dialog>


      <el-dialog
        v-model="applyInfoFlag"
        title="报名详情"
        width="50%"
      >
        <ul class="apply_box">
          <li class="apply_item" v-for="(item,index) in personalValue" :key="index">
            <div class="message" v-if="item.type!=2 && item.type!=11  && item.type!=13">
              <span class="item_label">{{ item.label }}：</span>
              <span class="item_value">{{ item.value }}</span>
            </div>
            <div class="message" v-if="item.type==2">
              <span class="item_label">{{ item.label }}：</span>
              <el-tag class="item_value item_tip" v-for="(cell,idx) in item.value" :key="idx">{{ cell }}</el-tag>
              <!-- <span class="item_value item_tip" v-for="cell in item.value">{{ cell }}、</span> -->
            </div>
            <div class="message" v-if="item.type==11">
              <span class="item_label">{{ item.label }}：</span>
              <el-image
                v-if="item.value"
                  style="width: 100px; height: 100px"
                  :src="item.value"
                  :zoom-rate="1.2"
                  :max-scale="7"
                  :min-scale="0.2"
                  :preview-src-list="[item.value]"
                  :initial-index="0"
                  fit="cover"
                />
                <span v-else>-</span>
            </div>
            <div class="message" v-if="item.type==13">
              <span class="item_label">{{ item.label }}：</span>
              <el-link :href="item.value" target="_blank" v-if="item.value">{{ item.filename }}</el-link>
              <span v-else>-</span>
            </div>
          </li>

        </ul>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="closePersonal">
              关闭
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import { Plus } from "@element-plus/icons-vue";
  // import addCompany from "./addCompany.vue";
  import { Ajax, MessageTips } from "@/utils";
  import Header from "@/Layout/components/Header.vue";
  import BreadCrumb from '@/components/BreadCrumb/index.vue'
  import { ElMessageBox } from "element-plus";
  // import SearchFilterBar from "@/components/SearchFilterBar/index.vue";
  // import fileDownload from'js-file-download'
  export default {
    components: {
      Plus,
      // addCompany,
      Header,
      BreadCrumb,
      // SearchFilterBar
    },
    setup() {
      const router = useRouter();
      const route = useRoute();
      const breadList = ref([
        {
          name: "活动",
          path: {
            name: "Activity",
          },
        },
        {
          name: "报名详情",
        },
      ]);
      const DetailInfo = ref({base:''});
      const ListData = ref([]);  
      const isLoading = ref(true)
      const dialogVisible = ref(false)
      
      // const payOptions = ref([
      //   {value: "1",label: "已支付" },
      //   {value: "2",label: "未支付" },
      //   {value: "3",label: "支付完成" },
      //   {value: "4",label: "免费" },
        
      // ])
      const paymentOptions = ref([
        {value: "1",label: "已支付" },
        {value: "2",label: "未支付" },
        {value: "3",label: "支付完成" },
        {value: "4",label: "免费" },
        
      ])
      const stateOptions = ref([
        {value: "1",label: "未审核" },
        {value: "2",label: "审核通过" },
        {value: "3",label: "审核失败" },
        
      ])
      const payState = ref('')
      const stateValue = ref('')
      const pageNum=ref(1)
      const paginationData = ref({
        current: 1,
        size: 10,
        total: 0,
      });

      const params = ref({
        pay:'',
        check:'',
        size:10,
        page:1,
      })
      const md5 = ref('')
      const getInfo = async () => {
        params.value.page = pageNum.value
        const ret = await Ajax.POST({
          url: "/admin/activity/register/" + route.query.id,
          data:params.value
        });
        if (ret.data.code === 200) {
          DetailInfo.value = ret.data.data;
          
          ret.data.data.items.forEach(item=>{
            item.content = JSON.parse(item.content)
          })
          ListData.value = ret.data.data.items
          isLoading.value = false
          paginationData.value.total = ret.data.total
          md5.value = ret.data.data.base.md5
        } else {
          MessageTips.error(ret.data.msg);
        }
      };
      const handleSearch = ()=>{
        params.value.pay =payState.value
        params.value.check =stateValue.value
        getInfo()
      }
      const handleCurrentChange = (val) => {
        pageNum.value = val;
        paginationData.value.current = val;
        getInfo();
      };
      // const exportUrl=ref('')
      onMounted(() => {
        getInfo();
        
        // exportUrl.value=window.env.baseUrl+"admin/activity/register/down/" + route.query.id
      });
  
      // 编辑
      const handleEdit = () => {
        router.push({
          name: "reportsListEdit",
          params: {
            id: route.query.id,
          },
        });
      };
      //审核
      const reason = ref('')
      const reasonId=ref('')
      const handleAudit = (id,type)=>{
        
        if(type==3){
          reasonId.value = id
          dialogVisible.value = true
        }else{
          let str = type == 2 ? "通过" : "不通过";
          ElMessageBox.confirm("确认" + str + "审核?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              setStatus(id, type);
            })
            .catch(() => {
              MessageTips.info("已取消" + str);
            });
        }
        
      }
      //审核操作
      
      const setStatus =async (id, type)=>{
        const res = await Ajax.POST({
          url: "/admin/activity/check/" + id,
          data: { status: type, reason:reason.value },
        });
        if (res.data.code === 200) {
          MessageTips.success("审核成功");
          if(type==3){
            closeDialog()
          }
        } else {
          MessageTips.error(res.data.msg);
        }

      }
      //审核不通过
      const confirmReason = ()=>{
        if(reason.value==''){
          MessageTips.info("请填写审核不通过的原因");
        }else{
          setStatus(reasonId.value,3)
          dialogVisible.value=false
        }
      }
      const closeDialog = ()=>{
        reasonId.value=''
        dialogVisible.valie = false
      }
      //下载
      const handleExport = () =>{
        let downUrl = `${window.env.baseUrl}admin/activity/register/down/${route.query.id}?m=${md5.value}`
        window.open(downUrl)
      }
      //查看报名详情
      const personalValue=ref([])
      const applyInfoFlag = ref(false)
      const handleDetail = (data)=>{
        console.log(data)
        
        let  breadList = [];
        data.forEach(item=>{
          if(item.type==1 || item.type==6 || item.type==8  || item.type==10 || item.type==11 || item.type==13){
            
            let info = {
              type:item.type,
              label:item.label,
              value:item.value
            };
            if(item.filename){
              info.filename=item.filename
            }
            breadList.push(info)
          }
          if(item.type==2){
            let choseValue=[]
            item.option.forEach(cell=>{
              if(item.value.includes(cell.value.toString())){
                choseValue.push(cell.label)
              }
            })
            breadList.push({
              type:item.type,
              label:item.label,
              value:choseValue
            })
          }
          if(item.type==3){
            breadList.push({
              type:item.type,
              label:item.label,
              value:item.selectLabel
            })
          }
          if(item.type==4){
            let choseValue=''
            item.option.forEach(cell=>{
              if(item.value==cell.value){
                choseValue+=cell.label
              }
            })
            breadList.push({
              type:item.type,
              label:item.label,
              value:choseValue
            })
          }
          if(item.type==5){
            breadList.push({
              type:item.type,
              label:item.label,
              value:item.levelone_name+' '+item.leveltwo_name
            })
          }
          if(item.type==9){
            breadList.push({
              type:item.type,
              label:item.label,
              value:item.country_name+' '+item.province_name
            })
          }
        })
        personalValue.value = breadList
        applyInfoFlag.value =true
        console.log(breadList)
      }
      const closePersonal = ()=>{
        personalValue.value = []
        applyInfoFlag.value =false
      }
      return {
        breadList,
        handleEdit,
        DetailInfo,
        isLoading,
        ListData,
        paymentOptions,
        stateOptions,
        payState,
        stateValue,
        handleAudit,
        handleSearch,
        dialogVisible,
        reason,
        confirmReason,
        closeDialog,
        paginationData,
        handleCurrentChange,
        handleExport,
        handleDetail,
        personalValue,
        applyInfoFlag,
        closePersonal,
        // exportUrl
      };
    },
    methods: {
      showAdress(row, colum) {
        if (row.city_name) {
          return row.city_name;
        }
        if (row.province_name) {
          return row.province_name;
        }
  
        return "";
      },
      pushDate(row, colum) {
        function add0(m) {
          return m < 10 ? "0" + m : m;
        }
        if (row > 0) {
          var time = new Date(row * 1000);
          var y = time.getFullYear();
          var m = time.getMonth() + 1;
          var d = time.getDate();
          var h = time.getHours();
          var mm = time.getMinutes();
          var s = time.getSeconds();
          return (
            y +
            "-" +
            add0(m) +
            "-" +
            add0(d) +
            " " +
            add0(h) +
            ":" +
            add0(mm) +
            ":" +
            add0(s)
          );
        }
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .message{
    display: flex;
    align-items: center;
  }
  .apply_item{
    margin-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;
    padding: 10px 0;
  }
  .item_label{
    min-width: 100px;
    display: inline-block;
    text-align: right;
    // background: #8c939d;
  }
  .item_tip{
    margin-right: 10px;
  }
  .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
    ::v-deep(.el-tabs__content) {
      flex: 1;
      overflow-y: auto;
    }
  }
  .basic-container {
    word-break: break-all;
    .form-box {
      width: 100%;
    }
    .avatar-uploader {
      width: 108px;
      height: 108px;
      ::v-deep(.el-upload) {
        width: 108px;
        height: 108px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 108px;
        height: 108px;
        line-height: 108px;
        text-align: center;
      }
    }
    .submit-box {
      background-color: #fff;
    }
    .aboutitem{
      margin-right: 20px;
    }
  }
  .main_box{
    padding: 20px;
    .title_box{
        display: flex;
        justify-content: space-between;
        h1{
            font-size: 24px;
            font-weight: bold;
        }
    }
    .search_box{
        display: flex;
        margin-top: 20px;
        width:100%;
        .search_inp{
            width: 200px;
        }
        .export{
            margin-left: 100px;
        }
        .search_box_input{
          min-width:600px
          .serch_list{
            display:flex
            li{
              display:flex;
              max-width:200px;
            }
          }
        }
    }
    .serch_list{
      display:flex;
      flex-direction:row;
      li{
              display:flex;
              max-width:300px;
              align-items:center;
            }
    }
    .search_box_input{
      min-width:600px;
      display:flex;
    }
    .data_box{
        margin-top: 40px;
    }
  }
  </style>
  